import { render, staticRenderFns } from "./_Company.vue?vue&type=template&id=16e63119&scoped=true"
import script from "./_Company.vue?vue&type=script&lang=js"
export * from "./_Company.vue?vue&type=script&lang=js"
import style0 from "./_Company.vue?vue&type=style&index=0&id=16e63119&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e63119",
  null
  
)

export default component.exports